import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ConversionFlow from './ConversionFlow';

export default function ConversionFlowWrapper({ open = null, onClose = () => {}, flowUrl, uspsLease, usps, triggerSelector, triggerEvent = 'click', vehicle = null, datalayerData }) {
    const form = useForm({ shouldUnregister: true });
    const [internalOpen, setInternalOpen] = useState(false);
    const [addConversionParam, setAddConversionParam] = useState(false);
    const [sourceFlow, setSourceFlow] = useState('');
    const isDomTriggered = open === null;

    useEffect(() => {
        if (!triggerSelector || !isDomTriggered) return;

        const triggerElements = Array.from(document.querySelectorAll(triggerSelector));
        const handler = (e) => {
            const isConversion = e.currentTarget.hasAttribute('data-flow-conversion');
            const sourceFlowValue = e.currentTarget.getAttribute('data-source-flow');
            if (isConversion) setAddConversionParam(true);
            if (sourceFlowValue) setSourceFlow(sourceFlowValue);
            e.preventDefault();
            setInternalOpen(true);
        };

        triggerElements.forEach((el) => el.addEventListener(triggerEvent, handler));
        return () => triggerElements.forEach((el) => el.removeEventListener(triggerEvent, handler));
    }, []);

    const handleClose = () => {
        if (isDomTriggered) {
            setInternalOpen(false);
            setAddConversionParam(false);
            setSourceFlow('');
        } else {
            onClose();
        }
    };

    return (
        <ConversionFlow
            flowUrl={flowUrl}
            uspsLease={uspsLease}
            usps={usps}
            vehicle={vehicle}
            datalayerData={datalayerData}
            open={isDomTriggered ? internalOpen : open}
            handleClose={handleClose}
            addConversionParam={addConversionParam}
            sourceFlow={sourceFlow}
            form={form}
        />
    );
}
